import React, { FC, ReactElement } from 'react';
import classNames from 'classnames';

import { SubscribeCardProps } from 'buyside/components/presentation/Subscribe/SubscribeCard';
export type SubscribeCardHeaderProps = Pick<
  SubscribeCardProps,
  'isCurrentTier' | 'price' | 'type'
> & {
  subscriptionTier: SubscribeCardProps['title'];
};

import styles from './subscribeCardStyles.scss';

const SubscribeCardHeader: FC<SubscribeCardHeaderProps> = ({
  isCurrentTier,
  price,
  subscriptionTier,
  type
}): ReactElement => (
  <>
    <div
      className={classNames(styles.subscriptionTier, {
        [styles.currentTierAdjustment]: isCurrentTier
      })}
    >
      <p className={classNames({ [styles.tierLabel]: isCurrentTier })}>{subscriptionTier}</p>
      {isCurrentTier ? <p className={styles.currentLabel}>Current Plan</p> : null}
    </div>
    <div className={styles.annualPrice}>
      <h1>${price.toLocaleString()}</h1>
      <p>{type}</p>
    </div>
  </>
);

export default SubscribeCardHeader;
